import { AUTH_MODE } from '@/shared/config';

/**
 * Checks a stored authentication mode against the two the app supports. Accepts only the SSO and username-password constants.
 *
 * @param authMode - Value read from storage or configuration.
 * @returns True when the value is one of the supported authentication modes.
 */
const isValidAuthMode = (authMode: string) =>
  authMode === AUTH_MODE.SSO || authMode === AUTH_MODE.USERNAME_PASSWORD;

/**
 * Determines which authentication mode the app should start in. Reads authMode out of localStorage and keeps it when valid, falling back to username and password.
 *
 * @returns The resolved authentication mode.
 */
const resolveAuthMode = () => {
  const localAuthMode = global.window?.localStorage?.authMode;
  if (isValidAuthMode(localAuthMode)) {
    return localAuthMode;
  }

  return AUTH_MODE.USERNAME_PASSWORD;
};

export { isValidAuthMode, resolveAuthMode };
